module.exports = __webpack_public_path__ + "img/CalendarBlank.9071b43b.svg";